"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializeAuth0Client = void 0;
class InitializeAuth0Client {
    constructor(authService) {
        this.authService = authService;
    }
    execute(request) {
        const { config } = request;
        return this.authService.initializeAuth0Client(config);
    }
}
exports.InitializeAuth0Client = InitializeAuth0Client;
